<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
  <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="placeForm" @submit="editPlace" :validation-schema="placeSchema" :initial-values="placeForm">
          <div class="row">
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field v-model="code" name="code" type="text" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le  code"/>
                  <ErrorMessage name="code" class="text-danger"/>
                </div>
              </div>
              
            

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Superficie<span class="text-danger">*</span>
                  </label>
                  <Field v-model="superficie" name="superficie" type="number" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer la superficie"
                  @keydown="(event) => ['0','e', 'E', '-'].includes(event.key) && event.preventDefault()"
                  />
                  <ErrorMessage name="superficie" class="text-danger"/>
                </div>
              </div>
  
            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Loyer de base<span class="text-danger">*</span>
                  </label>
                  <Field v-model="loyerBase" name="loyerBase" type="number" 
                  class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le loyer de base"
                  @keydown="(event) => ['0','e', 'E', '-'].includes(event.key) && event.preventDefault()"
                  />
                  <ErrorMessage name="loyerBase" class="text-danger"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Categorie d'activité<span class="text-danger">*</span>
                </label>
                <Field name="categorieActivite"
                v-model="categorieActivite"
                type="text" v-slot="{ field }">
                <Multiselect   
                v-model="field.value"
                v-bind="field" :options="categorieActiviteOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner la catégorie"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="categorieActivite" class="text-danger" />
              </div>
            </div>

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Marché<span class="text-danger">*</span>
                </label>
                <Field name="marche" type="text"
                v-model="marche"
                v-slot="{ field }">
                <Multiselect 
                v-model="field.value"
                v-bind="field" :options="marcheOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner le marché"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="marche" class="text-danger" />
              </div>
            </div>

            <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                Type<span class="text-danger">*</span>
                </label>
                <Field name="type" type="text"
                v-model="type"
                v-slot="{ field }">
                <Multiselect
                 v-model="field.value"
                 v-bind="field" :options="typeOptions" :preserve-search="true"
                   :multiple="false" :searchable="true" placeholder="Sélectionner le type"
                  label="label" track-by="label" />
                </Field>
                <ErrorMessage name="type" class="text-danger" />
              </div>
            </div>
        <div class="col-md-12 d-flex flex-column mt-3">
          <div class="d-flex align-items-center ">
            <button
              class="btn btn-success me-3"
              type="submit"
            >
                Modifier une place
            </button>
            <router-link to="/liste-place" 
                class=" btn btn-danger"><i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
          </div>
        </div>
      </div>
    </Form>
  </div>
</div>
</template>

<script lang="ts">

import { defineComponent, ref, onMounted } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRoute, useRouter } from 'vue-router';
import ApiService from '@/services/ApiService';
import { Place} from '@/models/Place';
import * as Yup from 'yup';
import axios from 'axios';
import Multiselect from '@vueform/multiselect';

export default defineComponent({
    name: "EditPlace",
    components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect

  },
  setup: () => {
    const placeSchema = Yup.object().shape({
      code: Yup.string().required("Code est obligatoire."),
  //reference: Yup.string().required("Reference est obligatoire."),
  superficie: Yup.string().required("Superficie est obligatoire."),
  loyerBase: Yup.string().required("Loyer de base est obligatoire."),
  categorieActivite: Yup.string().required("Categorie activite est obligatoire."),
  marche: Yup.string().required("Marche est obligatoire."),
  type: Yup.string().required("Type est obligatoire."),
  //statut: Yup.string().required("Statut est obligatoire."),
});
    const placeForm = ref<Place>();
      const categorie_activite= ref();
      const type = ref();
      const marche = ref();
      const loyerBase = ref();
      const superficie= ref();
      const code = ref();
      const categorieActivite = ref();
      const categorieActiviteOptions = ref();
      const marcheOptions = ref();
      const typeOptions = ref();
      

      const statut = ref();
  
    const router = useRouter();
    const route = useRoute();

    
const  getPlace  = async (id: number) => {
            console.log(id, "Place recupéré")
            return ApiService.get("/places/" + id)
                .then(({ data }) => {
                    const donnees = data.data;
                    console.log(donnees, 'donnéees');
                   marche.value=donnees?.marche.id;
                   type.value=donnees?.type.id;
                   categorieActivite.value=donnees?.categorieActivite.id;
                   code.value=donnees?.code;
                   superficie.value=donnees?.superficie;
                   loyerBase.value=donnees?.loyerBase;                   


                    for (const key in donnees) {
                      placeForm.value?.setFieldValue(key,
                            (typeof donnees[key] === 'object' && donnees[key] !== null) ? donnees[key].id : donnees[key]
                        );
                    }
                  //  emit('openmodal', addElementElectriqueModalRef.value);
                })
                .catch(({ response }) => {
                    error(response.data.message)
                });
        }

const editPlace = async (values, { resetForm }) => {
  try {
    const response = await ApiService.put(`/places/${values.id}`, values);
    
    if (response.status === 200) {
      success(response.data.message);
      resetForm();
      router.push({ name: "ListePlacePage" });
    }
  } catch (error) {
   // error(error.response?.data?.message || "Une erreur est survenue.");
  }
};

const getAllMarches = async () => {
          try{
          const response = await ApiService.get('/all/marches');
          const marchesData = response.data.data.data;
          console.log('Data', marchesData)
          marcheOptions.value = marchesData.map((marche) => ({
            value: marche.id,
            label: marche.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }

                 
    const getAllTypes = async () => {
          try{
          const response = await ApiService.get('/all/types');
          const typesData = response.data.data.data;
          console.log('Data', typesData)
          typeOptions.value = typesData.map((type) => ({
            value: type.id,
            label: type.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }
    const getAllCategorieActivites = async () => {
          try{
          const response = await ApiService.get('/all/categorieActivites');
          const categorieActivitesData = response.data.data.data;
          console.log('Data', categorieActivitesData)
          categorieActiviteOptions.value = categorieActivitesData.map((categorieActivite) => ({
            value: categorieActivite.id,
            label: categorieActivite.libelle,
          }));
          }
          catch(error){
            //error(response.data.message)
          }
        }

    onMounted(async () => {
      await getAllCategorieActivites();
       await getAllMarches();
      await  getAllTypes();
     if (route.params.id) {
       await getPlace(parseInt(route.params.id as string));
      }
    });

    return { 
      placeSchema, 
      editPlace, 
      placeForm, 
       categorieActiviteOptions,
          marcheOptions,
          typeOptions,
          getAllTypes,
          statut,
          type,
          marche,
          categorieActivite,
          superficie,
          code,
          loyerBase
    };
  },
});
</script>